import { render } from "./Ad.vue?vue&type=template&id=a85d1a74&scoped=true&ts=true"
import script from "./Ad.vue?vue&type=script&lang=ts"
export * from "./Ad.vue?vue&type=script&lang=ts"

import "./Ad.vue?vue&type=style&index=0&id=a85d1a74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85d1a74"]])

export default __exports__